<template>
    <div>
        <flex-row class="flex--button-below-label">
            <div class="col items-selector-container-narrow">
                <items-typeahead
                    :id="`search-sku_${parent.id || parent.idx}-new-item`"
                    :name="`search-sku_${parent.id}-new-item`"
                    :value="selectedItem.sku"
                    :label="$t('items.labels.sku')"
                    :preloaded-options="items"
                    placeholder=""
                    spacing="xs"
                    :allow-empty="false"
                    :validation="{name: $t('items.labels.sku')}"
                    @input="onItemSelected"
                    @skus-loaded="(loadedOptions) => saveSearchResult(loadedOptions)"
                />
            </div>
            <div v-if="!hideInputQty"
                 class="col col--width-qty"
            >
                <form-input
                    :id="`search-sku_${parent.id || parent.idx}-new-item-quantity`"
                    v-model="selectedItem.quantity"
                    :name="`search-sku_${parent.id}-new-item-quantity`"
                    :label="$t('items.labels.quantity')"
                    spacing="xs"
                    type="number"
                    step="1"
                    min="1"
                    :rules="`min_value:1|max:9`"
                    :validation="{name: $t('items.labels.quantity')}"
                />
            </div>
        </flex-row>

        <flex-row class="selected-item-info">
            <div class="item-info-section col">
                <label class="info-section-label">
                    {{ $t('consumerOrders.labels.skuDescription') }}
                </label>
                <div class="info-section-text">
                    {{ selectedItem.description }}
                </div>
            </div>
            <div
                v-if="!hideAvailableQty"
                class="item-info-section col col--width-qty"
            >
                <label class="info-section-label">
                    {{ $t('consumerOrders.labels.totalQty') }}
                </label>
                <div class="info-section-text">
                    {{ getAvailableCount() }}
                </div>
            </div>

            <div v-if="isSelectItemLotTacked === false || isShowLotTrackedItem === false"
                 class="item-info-section col col--width-qty"
            >
                <div class="info-section-button with-button">
                    <base-button
                        primary
                        :disabled="isDisableInputQuantity"
                        @click="addItem()"
                    >
                        {{ inputQtyText }}
                    </base-button>
                </div>
            </div>
        </flex-row>

        <flex-row
            v-if="isSelectItemLotTacked === true && isShowLotTrackedItem === true
                && selectedItem.availableQty > 0"
            class="flex--button-below-label"
        >
            <div class="col items-selector-container-narrow">
                <form-select id="item-lotTrack-number"
                             v-model.trim="selectedItem.lotNumber"
                             :options="selectedItem.displayLotNumbers"
                             name="item-lotTrack-number"
                             :searchable="false"
                             option-label="lotNumber"
                             value-field="lotNumber"
                             track-by="lotNumber"
                             :label="$t('items.labels.lotNumber')"
                             @input="onLotTrackItemChange"
                />
            </div>
            <div class="col col--width-qty">
                <form-input
                    :id="`search-sku_${parent.id || parent.idx}-new-item-quantity`"
                    v-model="selectedItem.availableLotQty"
                    :name="`search-sku_${parent.id}-new-item-quantity`"
                    :label="$t('items.labels.availableQty')"
                    :disabled="true"
                    :validation="{name: $t('items.labels.quantity')}"
                />
            </div>
        </flex-row>

        <flex-row
            v-if="isSelectItemLotTacked === true && isShowLotTrackedItem === true
                && selectedItem.availableQty > 0"
            class="selected-item-info"
        >
            <div class="item-info-section col">
                <form-select v-if="selectedItem.isExpirationTracked"
                             id="item-lotTrack-expirationDate"
                             v-model.trim="selectedItem.expirationDate"
                             :options="selectedExpirationDates"
                             name="item-lotTrack-expirationDate"
                             :searchable="false"
                             option-label="expirationDate"
                             value-field="expirationDate"
                             track-by="expirationDate"
                             :label="$t('items.labels.expirationdate')"
                             @input="onLotTrackItemExpirationDateChange"
                />
            </div>
            <div class="info-two-section-button with-button">
                <base-button
                    primary
                    :disabled="isDisableInputQuantity"
                    :style="{
                        margin: selectedItem.isExpirationTracked ? '47px 15px' : '0px 18px 5px'
                    }"
                    @click="addItem()"
                >
                    {{ inputQtyText }}
                </base-button>
            </div>
        </flex-row>

        <flex-row
            v-if="isLotTrackExpandSelectDisplay === true && isShowLotTrackedItem === false && isSelectItemLotTacked === true
                && selectedItem.availableQty > 0"
            class="flex--button-below-label"
        >
            <div class="col items-selector-container-narrow">
                <div class="info-section-button with-button">
                    <base-button id="add-lotTracked-line"
                                 as-link
                                 @click="addLotTrackedItem"
                    >
                        <svg slot="iconLeft"
                             width="20"
                             height="20"
                        >
                            <use xlink:href="#plus-round" />
                        </svg>
                        {{ $t('items.labels.lotnumberExpandSelectLot') }}
                    </base-button>
                </div>
            </div>
        </flex-row>

        <flex-row class="selected-item-info">
            <div v-if="isVisibleRecordSerialNumber && selectedItem.isSerialTracked"
                 class="item-info-section col radio-check"
            >
                <base-radio-check id="selected-is-record-serial-number"
                                  :value="selectedItem.isRecordSerialNumber"
                                  type="checkbox"
                                  :label="$t('items.labels.requiredSerialNumberCapture')"
                                  :tooltip-text="$t('items.labels.requiredSerialNumberCaptureToolTip')"
                                  @input="onIsRecordSerialNumber"
                />
            </div>
        </flex-row>
    </div>
</template>

<script>
import { BaseButton } from '@/components/buttons';
import { FormInput } from '@/components/form';
import ItemsTypeahead from '@/components/ItemsTypeahead';
import { BaseRadioCheck } from '@/components/base';
import FormSelect from '@/components/form/FormSelect';
// eslint-disable-next-line no-unused-vars
import { $t } from '@/translations';

const defaultItem = {
    sku: '',
    description: '',
    quantity: null,
    availableQty: null,
    errorMessage: null,
    availableInventories: null,
    isRecordSerialNumber: false,
    isLotTracked: false,
    lotNumber: null,
    expirationDate: null,
    availableLotQty: null,
    isSerialTracked: false,
    isExpirationTracked: false,
    isProductionDateTracked: false,
};

export default {
    name: 'SearchItem',
    components: {
        BaseButton,
        FormInput,
        FormSelect,
        ItemsTypeahead,
        BaseRadioCheck,
    },
    props: {
        itemParent: {
            type: Object,
            required: true,
        },
        itemsList: {
            type: Object,
            default: () => null,
        },
        hideAvailableQty: {
            type: Boolean,
            default: false,
        },
        selectedWarehouse: {
            type: String,
            default: null,
        },
        hideInputQty: {
            type: Boolean,
            default: false,
        },
        inputQtyText: {
            type: String,
            default: $t('items.labels.addSku'),
        },
        isVisibleRecordSerialNumber: {
            type: Boolean,
            default: false,
        },
        isLotTrackExpandSelectDisplay: {
            type: Boolean,
            default: false,
        },
        isDisplayExpiredLotDetail: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            selectedItem: { ...defaultItem },
            isShowLotTrackedItem: false,
            selectedExpirationDates: [],
        };
    },
    computed: {
        parent() {
            return this.itemParent;
        },
        items() {
            return this.itemsList;
        },
        isDisableInputQuantity() {
            if (this.hideInputQty === true) {
                return !this.selectedItem.sku;
            }

            return !this.selectedItem.sku || this.selectedItem.quantity == null || this.selectedItem.quantity < 1;
        },
        getLotInventoryTotalCount() {
            return this.selectedItem.availableLotQty;
        },
        getAvailableCount() {
            return () => {
                if (this.selectedWarehouse == null || this.selectedItem.availableInventories == null) {
                    return this.selectedItem.availableQty;
                }

                const itemWarehouse = this.selectedItem.availableInventories
                    .find(i => i.warehouseName.toUpperCase() === this.selectedWarehouse.toUpperCase());
                if (itemWarehouse) {
                    return itemWarehouse.availableInventoryQuantity;
                }

                return 0;
            };
        },
        isWarehouseSelected() {
            return this.selectedWarehouse !== null;
        },
        isSelectItemLotTacked() {
            return this.selectedItem.isLotTracked;
        },
        isLotTrackItemWithWarehouseSelected() {
            return this.isWarehouseSelected && this.selectedItem.isLotTracked === true;
        },
    },
    methods: {
        clearSelection() {
            this.selectedItem.sku = '';
            this.selectedItem.description = '';
            this.selectedItem.quantity = null;
            this.selectedItem.availableQty = null;
            this.selectedItem.errorMessage = null;
            this.selectedItem.availableInventories = null;
            this.selectedItem.isRecordSerialNumber = false;
            this.selectedItem.isLotTracked = false;
            this.selectedItem.lotNumber = null;
            this.selectedItem.expirationDate = null;
            this.selectedItem.availableLotQty = null;
            this.selectedItem.isSerialTracked = false;
            this.selectedItem.isExpirationTracked = false;
            this.selectedItem.isProductionDateTracked = false;
        },
        async addItem() {
            if (this.selectedItem.lotNumber !== null && this.selectedItem.isLotTracked === true && this.isShowLotTrackedItem === true) {
                if (this.isLotTrackItemWithWarehouseSelected === false) {
                    this.$toast.error($t('items.addLotItemError'));
                    return;
                }

                const quantity = this.selectedItem.availableLotQty === null || this.selectedItem.availableLotQty === undefined
                    ? this.selectedItem.availableQty : this.selectedItem.availableLotQty;
                if (this.selectedItem.quantity > quantity) {
                    this.$toast.error($t('items.addLotItemQuantityExceedsAvailableError'));
                    return;
                }

                if (this.selectedItem.isExpirationTracked && this.selectedItem.expirationDate === null) {
                    this.$toast.error($t('items.addLotItemExpirationDateError'));
                    return;
                }

                if (this.isLotTrackItemWithWarehouseSelected === true) {
                    const confirm = await this.askConfirmSaveLotTrackedItem();
                    if (confirm) {
                        await this.baseAddItem();
                    }

                    return;
                }
            }

            await this.baseAddItem();
        },
        setSelectedLotExpirationDate(value) {
            if (value === undefined || value === null) {
                this.selectedExpirationDates = [];
                return;
            }

            this.selectedExpirationDates = this.getExpirationDate(this.selectedItem.lotDataDictionary, this.itemParent.warehouseId, value);
        },
        getExpirationDate(lotDataDictionary, warehouseId, lotNumber) {
            if (!lotDataDictionary || !warehouseId || !lotNumber) {
                return null;
            }

            const lots = lotDataDictionary[warehouseId];
            if (!lots) {
                return [];
            }

            return lots
                .filter(l => l.lotNumber === lotNumber)
                .map(l => ({ expirationDate: l.expirationDate }));
        },
        getQuantityByLotAndExpiration(lotDataDictionary, warehouseId, lotNumber, expirationDate) {
            if (!lotDataDictionary || !warehouseId || !lotNumber || !expirationDate) {
                return 0;
            }

            const lots = lotDataDictionary[warehouseId] || [];
            const match = lots.find(l => l.lotNumber === lotNumber && new Date(l.expirationDate).getTime() === new Date(expirationDate).getTime());
            return match ? match.quantity : 0;
        },
        getQuantityByLot(lotDataDictionary, warehouseId, lotNumber) {
            if (!lotDataDictionary || !warehouseId || !lotNumber) {
                return 0;
            }

            const lots = lotDataDictionary[warehouseId] || [];
            const match = lots.find(l => l.lotNumber === lotNumber);
            return match ? match.quantity : 0;
        },
        onLotTrackItemExpirationDateChange(value) {
            if (typeof value !== 'string' || value === undefined || value === null) return;
            this.selectedItem.expirationDate = value;

            const quantity = this.getQuantityByLotAndExpiration(this.selectedItem.lotDataDictionary,
                this.itemParent.warehouseId,
                this.selectedItem.lotNumber,
                this.selectedItem.expirationDate);
            this.selectedItem.availableLotQty = quantity;
        },
        async baseAddItem() {
            this.$emit('item-added', { ...this.selectedItem });
            this.clearSelectedItem();
        },
        clearSelectedItem() {
            this.selectedItem = { ...defaultItem };
            this.isShowLotTrackedItem = false;
        },
        async saveSearchResult(loadedOptions) {
            this.$emit('items-list-loaded', loadedOptions);
        },
        onIsRecordSerialNumber(checked) {
            this.selectedItem.isRecordSerialNumber = checked;
        },
        onItemSelected(value) {
            if (typeof value !== 'object' || value === undefined || value === null) return;
            const filterLots = value.itemLots.filter(lot => lot.isRecalled === false
                    && lot.isExpired === false
                    && lot.isInExpirationWindow === false
                    && (lot.expirationDate === null || new Date(lot.expirationDate) > new Date()));

            // update local state
            this.selectedItem.sku = value.sku;
            this.selectedItem.description = value.description;
            this.selectedItem.hsCodeId = value.hsCodeId;
            this.selectedItem.availableQty = value.totalAvailableInventory;
            this.selectedItem.availableInventories = value.availableInventories;
            this.selectedItem.isSerialTracked = value.isSerialTracked;
            this.selectedItem.isLotTracked = value.isLotTracked;
            this.selectedItem.isProductionDateTracked = value.isProductionDateTracked;
            this.selectedItem.isExpirationTracked = value.isExpirationTracked;
            this.selectedItem.hazmatType = value.hazmatType;
            this.selectedItem.itemLots = value.itemLots;
            this.selectedItem.lotDataDictionary = this.getLotDataDictionary(filterLots);
            this.selectedItem.displayLotNumbers = this.getLotNumbers(this.selectedItem.lotDataDictionary, this.itemParent.warehouseId);
            this.selectedItem.lotNumber = null;
            this.selectedItem.expirationDate = null;
            this.selectedItem.availableLotQty = null;
            // emit event to parent
            this.$emit('item-selected', { ...this.selectedItem });
        },
        getLotNumbers(lotDataDictionary, warehouseId) {
            if (!lotDataDictionary || typeof lotDataDictionary !== 'object' || !warehouseId) {
                return [];
            }

            const lots = lotDataDictionary[warehouseId] || [];
            const unique = [...new Set(lots.map(x => x.lotNumber))];
            return unique.map(x => ({ lotNumber: x }));
        },
        getLotDataDictionary(itemLots) {
            const lotDataDictionary = {};
            itemLots.forEach((entry) => {
                const warehouseId = entry.warehouseId;
                if (!lotDataDictionary[warehouseId]) {
                    lotDataDictionary[warehouseId] = [];
                }

                lotDataDictionary[warehouseId].push({
                    expirationDate: this.$options.filters.date(entry.expirationDate, 'short'),
                    quantity: entry.quantity,
                    lotNumberWmsId: entry.lotNumberWmsId,
                    lotNumber: entry.lotNumber,
                });
            });

            return lotDataDictionary;
        },
        onLotTrackItemChange(value) {
            if (typeof value !== 'string' || value === undefined || value === null) return;
            this.selectedItem.lotNumber = value;
            if (this.selectedItem.isExpirationTracked === false) {
                const quantity = this.getQuantityByLot(this.selectedItem.lotDataDictionary,
                    this.itemParent.warehouseId,
                    this.selectedItem.lotNumber);

                this.selectedItem.availableLotQty = quantity;
                return;
            }

            this.selectedItem.expirationDate = null;
            this.selectedItem.availableLotQty = null;
            this.setSelectedLotExpirationDate(value);
        },
        addLotTrackedItem() {
            if (this.isLotTrackItemWithWarehouseSelected === false) {
                this.$toast.error($t('items.addLotItemError'));
                return;
            }

            this.isShowLotTrackedItem = true;
        },
        askConfirmSaveLotTrackedItem() {
            return new Promise((resolve) => {
                const textLines = [
                    this.$t('items.confirmLotTrackedItemSave'),
                    `Lot Number: ${this.selectedItem.lotNumber}`,
                    `Quantity: ${this.selectedItem.quantity}`,
                ];

                if (this.selectedItem.expirationDate) {
                    textLines.splice(2, 0, `Exp. Date: ${this.selectedItem.expirationDate}`);
                }

                this.$dialog.info({
                    title: '',
                    text: textLines,
                    buttons: [
                        { title: $t('general.filters.boolean.yes'), handler: () => resolve(true), close: true },
                        { title: $t('general.filters.boolean.no') },
                    ],
                }, {}, {
                    closed: () => resolve(false),
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.selected-item-info {
    margin-bottom: 20px;

    .item-info-section {
        margin: 0 5px;

        .info-section-label {
            display: inline-block;
            padding: 8px 0;
            color: $color-gray-400;
            font-size: $font-size-sm;
            font-weight: 500;
            line-height: $line-height-base;
            text-transform: uppercase;
        }

        &.radio-check {
            position: relative;
            line-height: 20px;
            text-align: left;
        }

        .info-section-text {
            width: 100%;
            min-height: $input-height;
            padding: 9px 13px;
            border-radius: $input-border-radius;
            background-color: $color-teal-950;
            color: $color-gray-200;
            font-size: $font-size-base;
            word-break: break-word;
        }

        .info-section-button {
            width: 100%;
            min-height: $input-height;
            padding: 1px 1px;
            border-radius: $input-border-radius;
            background-color: $color-teal-950;
            color: $color-gray-200;
            font-size: $font-size-base;
            word-break: break-word;

            &.with-button {
                background-color: $color-white;

                button {
                    width: 100%;
                    margin-top: 32px;
                    padding: 9px;
                }
            }
        }

        .info-two-section-button {
            width: 150px;
            min-height: $input-height;
            padding: 1px 1px;
            border-radius: $input-border-radius;
            background-color: $color-teal-950;
            color: $color-gray-200;
            font-size: $font-size-base;
            word-break: break-word;

            &.with-button {
                background-color: $color-white;

                button {
                    width: 100%;
                    margin-top: 32px;
                    padding: 9px;
                }
            }

            .btn-with-exp {
                margin: 47px 15px;
            }
        }
    }

    .item-empty-space {
        flex-grow: 0;
        min-width: 20px;
    }
}
</style>
